import { useEffect, useState } from "react"
import { Button } from "react-aria-components"
import { httpPost } from "../../../../../modules/Backend"
import { httpGet } from "../../../../../modules/Backend"
import FormSelectWrapper from "../../../entityComponents/Form/components/FormSelectWrapper"
import { EntityNames } from "../../../../../enums/EntityNames"
import FormTextInputWrapper from "../../../entityComponents/Form/components/FormTextInputWrapper"
import PrintRecallPackList from "../../../print/PrintRecallPackList"
import { modalSignal } from "../../../Modal/ModalContainer"
import ContinueModal from "../../../Modal/ConfirmModal"
import { HttpStatusCode } from "axios"
import { useNavigate } from "react-router"

export default function SidePanelRecallPackList({ recallId }: { recallId: string }) {
    const [data, setData] = useState<any>();
    const [submitting, setSubmitting] = useState<any>(false);
    const navigate = useNavigate();
    const [showCourierUrl, setShowCourierUrl] = useState(true);
    const [courierData, setCourierData] = useState<any>();

    useEffect(() => {
        async function fetchCourierData() {
            try {
                const result = await httpGet(`api/${EntityNames.couriers}/list`);
                if (result.data && result.data.couriers) {
                    setCourierData(result.data.couriers);
                }
            } catch (err) {
                console.error("Error fetching couriers:", err);
            }
        }
    
        fetchCourierData();
    }, []);

    async function getData() {
        var result = await httpGet(`api/${EntityNames.recalls}/get?id=${recallId}`)
        if (result.data) {
            setData({ ...result.data })
        }
    }

    const handleChange = (input: string) => (value: string) => {        
        if (input === "courierId") {
            const selectedCourier = courierData.find((courier: { value: string }) => courier.value === value);
            setShowCourierUrl(selectedCourier?.text !== "TNT");
        }
        setData({ ...data, [input]: value });
    };

    function onSumbissionCancelled() {
        setSubmitting(false);
    }

    async function submit() {
        const handle = async () => {
            setSubmitting(true);
            const response = await httpPost(`api/${EntityNames.recalls}/processPacklist`, {
                recallId: recallId,
                packagingId: data.packagingId,
                courierId: data.courierId,
                courierUrl: data.courierUrl,
                trackingCode: data.trackingCode
            })
            setSubmitting(false);
            if (response.status === HttpStatusCode.Ok) {
                navigate(`/view/${EntityNames.recalls}/${recallId}`, { replace: true });
            }
        }
        modalSignal.value = <ContinueModal heading="Pack Recall?" information="This action cannot be undone" ContinueFunc={handle} cancelFunc={onSumbissionCancelled} />
    }

    function validate() {
        const errors: Record<string, string> = {};
        if (!data) return errors

        if (data.requestType === "Physical") {
            if (!data.packagingId) {
                errors.packagingId = "Please choose a packaging item"
            }
            if (!data.courierId) {
                errors.courierId = "Please choose a courier"
            }
            if (data.courierUrl && !/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/.test(data.courierUrl)) {
                errors.courierUrl = "invalid courier website URL"
            }
        }

        return errors
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div className="display--flex flex__direction--column height--full">
            <div className="display--flex alignItems--end gap--xs">
                <h2>Recall {data?.reference}</h2>
            </div>
            {data && data.requestType === "Physical" &&
                <div className="display--flex gap--s flex__wrap--wrap margin__top--s">
                    <PrintRecallPackList recallId={recallId} />
                </div>
            }
            {data && data.requestType === "Physical" &&
                <div className="side-panel__info-box margin__top--s">
                    <div className="display--flex flex__direction--column gap--s">
                        <FormSelectWrapper value={data?.packagingId} entityName={EntityNames.packaging} required={true} onChange={handleChange("packagingId")} label={"Packaging"} />
                        <FormSelectWrapper value={data?.courierId} entityName={EntityNames.couriers} required={true} onChange={handleChange("courierId")} label={"Courier"} />
                        
                        {showCourierUrl && (
                        <FormTextInputWrapper value={data?.courierUrl} label="Courier website" required={false} validateRule={() => validate().courierUrl ? false : true} validationError={validate().courierUrl} onChange={handleChange("courierUrl")} />
                        )}

                        <FormTextInputWrapper value={data?.trackingCode} label="Delivery tracking code" required={false} validateRule={() => validate().trackingCode ? false : true} validationError={validate().trackingCode} onChange={handleChange("trackingCode")} />
                    </div>
                </div>
            }
            <div className="margin__top--auto">
                <Button type="button" className="button button--primary button--small" onPress={() => { submit() }} isDisabled={!data || submitting || (Object.keys(validate()).length > 0)}>
                    <p className="button-text">Save & Submit</p>
                </Button>
            </div>
        </div>
    )
}